import { Injectable } from '@angular/core';
import { AsyncSubject, Observable, distinctUntilChanged, map, noop } from 'rxjs';

import { ConsentForm } from '../models/consent-form.model';
import { DistinctSubject, recursiveQuery } from '../models/utility.model';
import { AuthUsecase } from '../usecases/auth.usecase';
import { ConsentFormGateway } from '../usecases/consent-form.gateway';
import { ConsentFormUsecase } from '../usecases/consent-form.usecase';

@Injectable()
export class ConsentFormInteractor extends ConsentFormUsecase {
  get consentForms$(): Observable<ConsentForm[]> {
    return this._consentForms;
  }

  private readonly _consentForms = new DistinctSubject<ConsentForm[]>([]);

  constructor(
    private _authUsecase: AuthUsecase,
    private _consentFormGateway: ConsentFormGateway,
  ) {
    super();

    this._authUsecase.authState$
      .pipe(
        map(({ status }) => status === 'signedIn'),
        distinctUntilChanged(),
      )
      .subscribe(signedIn => (signedIn ? noop : this.onSignOut()));
  }

  listConsentForms(): Observable<never> {
    const result = new AsyncSubject<never>();
    recursiveQuery(params => this._consentFormGateway.listConsentForms(params), {}).subscribe({
      next: consentForms => this._consentForms.next(consentForms),
      error: result.error.bind(result),
      complete: result.complete.bind(result),
    });
    return result.asObservable();
  }

  private onSignOut(): void {
    this._consentForms.next([]);
  }
}
